<template lang='pug'>
  .icon
    slot
</template>

<script>
export default {
  name: 'Icon',
};
</script>

<style lang='stylus' scoped>
.icon
  width 3em
  height 3em
</style>
